/**
 * EventDetailPanel — dispatcher between FeedbackDetailPanel and
 * ErrorDetailPanel based on the event type. Keeps EventRow agnostic about
 * which panel renders for which event kind.
 */

import React from 'react';
import type { PortalEvent } from '../../services/types';
import FeedbackDetailPanel from './FeedbackDetailPanel';
import ErrorDetailPanel from './ErrorDetailPanel';

interface Props {
  event: PortalEvent;
}

const EventDetailPanel: React.FC<Props> = ({ event }) => {
  if (event.type === 'feedback') {
    return <FeedbackDetailPanel feedbackId={event.id} />;
  }
  return <ErrorDetailPanel errorId={event.id} />;
};

export default EventDetailPanel;
